<template>
  <div class="card">
    <button v-b-modal="videoId ? videoId : ''" @click.prevent="handleClick" :class="`link-button btn-bird-tag-${index + 1}`" :disabled="!videoId">
      <div class="birder-image-wrapper"><b-img-lazy :src="avatar" :alt="name" class="birder-image" />
        <svg v-if="videoId" width="40" height="40" viewBox="0 0 40 41" fill="black" xmlns="http://www.w3.org/2000/svg"
          class="play-icon">
          <circle cx="20" cy="20.8794" r="19.3103" fill="#173945" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M0 20.8794C0 9.84532 8.96591 0.879395 20 0.879395C31.0341 0.879395 40 9.84532 40 20.8794C40 31.9134 31.0341 40.8794 20 40.8794C8.96591 40.8794 0 31.9134 0 20.8794ZM38.0488 20.8794C38.0488 10.8998 29.9796 2.83061 20 2.83061C10.0204 2.83061 1.95122 10.8998 1.95122 20.8794C1.95122 30.859 10.0204 38.9282 20 38.9282C29.9796 38.9282 38.0488 30.859 38.0488 20.8794ZM16.1433 10.6355C15.61 10.6475 15.0872 10.8016 14.6494 11.0776C13.7738 11.6295 13.1952 12.6407 13.1707 13.8062L13.1706 13.8175L13.1707 13.8367V27.9068V27.9219C13.1952 29.0874 13.775 30.111 14.6494 30.6658C15.5238 31.2208 16.7213 31.2766 17.7287 30.6961L17.7439 30.681L29.2226 23.6231C30.1326 23.0617 30.7317 22.0249 30.7317 20.8641C30.7317 19.7034 30.1326 18.6818 29.2226 18.1202L17.7439 11.0623L17.7287 11.0471C17.2258 10.7574 16.6766 10.6235 16.1433 10.6355L16.1433 10.6355ZM16.7226 12.7239C16.5262 12.617 16.3384 12.5671 16.1738 12.5715V12.5715C15.9995 12.5764 15.838 12.6281 15.686 12.7239C15.385 12.9137 15.1385 13.2859 15.122 13.8367V13.8519V27.8916V27.9067C15.1385 28.4578 15.3838 28.8277 15.686 29.0195C15.9828 29.2079 16.3198 29.2388 16.7226 29.0195C16.7279 29.0166 16.7323 29.0146 16.7366 29.0126C16.7417 29.0103 16.7468 29.0081 16.753 29.0044L28.2012 21.9617C28.5406 21.7522 28.7805 21.3587 28.7805 20.8641C28.7805 20.3696 28.5406 19.9912 28.2012 19.7818L16.753 12.7391C16.7468 12.7356 16.7419 12.7333 16.7368 12.731C16.7324 12.7289 16.728 12.7268 16.7226 12.7239Z"
            fill="white" />
        </svg>
        <div class="name">{{ name }}</div>
      </div>

    </button>
    <b-modal v-if="videoId" :id="videoId" :size="modalSize" centered hide-footer hide-header>
      <b-container fluid>
        <b-row class="controls">
          <b-col>&nbsp;</b-col>
          <b-col xs="12">
            <button @click="hideModal" class="icon-close modal-icon-close">&nbsp;</button>
          </b-col>
        </b-row>
        <b-row>
          <b-col xs="12" class="video-player">
            <b-embed type="iframe" :src="`https://www.youtube.com/embed/${videoId}`" allowfullscreen></b-embed>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </div>
</template>

<script lang="js">
import { BEmbed } from 'bootstrap-vue';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'BirderCard',
  components: {
    BEmbed,
  },
  props: {
    avatar: String,
    name: String,
    video_url: String,
    index: Number,
  },
  computed: {
    screenWidth: {
      get() {
        return window.innerWidth;
      },
    },
    videoId() {
      if (this.video_url === '') {
        return null;
      }
      return this.video_url.split('/').reverse()[0];
    },
    modalSize() {
      // const screenWidth = this.screenWidth;
      if (this.screenWidth < 768) {
        return 'sm';
      }
      return 'xl';
    },
  },
  methods: {
    handleClick() {
      if (this.video_url === '') {
        return;
      }
      this.$emit('click', this.video_url);
    },
    hideModal() {
      if (!this.videoId) {
        return;
      }
      this.$bvModal.hide(this.videoId);
    },
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.screenWidth = window.innerWidth;
      this.modalSize();
    });
  },
  unmounted() {
    window.removeEventListener('resize', () => {
      this.screenWidth = window.innerWidth;
      this.modalSize();
    });
  },
})
class BirderCard extends Vue {
}

export default BirderCard;
</script>

<style lang="scss" scoped>
.controls {
  min-height: 1em;
  padding-bottom: 2em;
}

.card {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 15px;
  width: 180px;
  border: none;
}

.birder-image-wrapper {
  transition: transform 1s ease-in-out;
  transition: transform 1s focus;

  .birder-image {
    border-radius: 50%;
    background-color: black;
    margin: .5em;
    height: 150px;
    width: 150px;
  }

  svg {
    position: absolute;
    top: 125px;
    left: 125px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    transform: translate3d(0px, 0px, 0);
    transition-property: 'top', left;
    transition-duration: .2s;
  }

  &:hover {
    svg {
      transform: translate3d(-52px, -62px, 0);
      transition-property: 'top', left;
      transition-duration: .2s;
    }
  }

}

.modal-icon-close {
  color: #4e97b2 !important;
  cursor: pointer;
  position: absolute;
  right: 20px;
  min-height: 3em;

  &:hover {
    color: #000 !important;
  }
}


.name {
  font-family: 'klinicslabbold';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  margin-bottom: 1em;
  text-decoration: none;
  color: #173945
}

.modal-backdrop {
  color: black !important;
  background-color: transparent !important;
  opacity: .59;

  @keyframes fadeInOpacity {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 0.59;
    }
  }
}

@media screen and (min-width: 300px) {
  .modal .modal-dialog .modal-sm {
    max-width: 90% !important;
    width: 90% !important;
  }
}

@media (min-width: 992px) {

  .modal .modal-dialog .modal-huge {
    max-width: 90% !important;
    width: 90% !important;
  }
}

.link-button {
  background: none;
  border: none;
  cursor: pointer;
  text-decoration: none;

  &:disabled {
    cursor: auto;
  }
}

.modal-icon-close {
  color: #4e97b2 !important;
  cursor: pointer;
  position: absolute;
  right: 20px;

  &:hover {
    color: #000 !important;
  }
}

// .video-player {
//   // padding-top: 2rem;
//   width: 100% !important;
//   // margin-left: -15px;
// }
</style>
